import React from 'react';

import { View } from 'react-native';

import styles from './styles';

function EmbeddedErrorBackground() {
    return <View style={styles.root} />;
}

export default EmbeddedErrorBackground;
